import { colors } from '@/colors';
import { Container } from '@/components/Container';
import useTranslation from '@/hooks/useTranslation';

interface IEmptySectionContactAdminProps<T> {
  items: T[];
  sectionName: string;
}

export const EmptySectionContactAdmin = <T,>({ items, sectionName }: IEmptySectionContactAdminProps<T>) => {
  const t = useTranslation();
  if (items.length > 0) {
    return null;
  }
  return (
    <Container
      className={'empty-section-contact-admin'}
      sx={{ textAlign: 'center', color: colors.initialized, margin: 'unset', width: '100%', padding: '8px 32px' }}
    >
      <span dangerouslySetInnerHTML={{ __html: t('admin.emptySection', undefined, undefined, { sectionName }) }} />
    </Container>
  );
};
